import { Reveal, ScrollMaskLine } from "./Reveal";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const SERVICES = [
  {
    n: "01",
    title: "Brand Identity",
    body: "Logos, brand marks, color systems and guidelines that give organizations a memorable, ownable presence.",
    tags: ["Logo Design", "Visual Identity", "Guidelines"],
  },
  {
    n: "02",
    title: "Digital Marketing",
    body: "Social media graphics, ad creative and email templates engineered to stop the scroll and drive action.",
    tags: ["Social Graphics", "Email", "Campaigns"],
  },
  {
    n: "03",
    title: "Print + Displays",
    body: "Flyers, banners, signage and large-format displays produced with print-ready precision.",
    tags: ["Flyers", "Banners", "Signage"],
  },
  {
    n: "04",
    title: "Publications",
    body: "Multi-page layouts, programs and editorial design that balance information with beauty.",
    tags: ["Layout", "Editorial", "Programs"],
  },
  {
    n: "05",
    title: "Custom Creative",
    body: "Bespoke concepts for events, launches and special projects — when off-the-shelf simply won't do.",
    tags: ["Events", "Concepts", "Special Projects"],
  },
  {
    n: "06",
    title: "Portal & Workflow Design",
    body: "Custom branded systems that simplify submissions, approvals, project tracking, resource access, and document delivery.",
    tags: ["Portals", "Workflow", "Automation", "SaaS"],
  },
];

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-28 md:py-40 bg-[#0b0618]"
    >
      <div className="pointer-events-none absolute top-1/3 -left-40 h-[60vh] w-[60vh] glow-radial opacity-40" />
      <div className="mx-auto max-w-[1500px] px-6 md:px-12 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <div className="lg:sticky lg:top-28">
            <Reveal className="text-xs uppercase tracking-[0.35em] text-[#C77DFF] mb-6">
              What we do
            </Reveal>
            <h2 className="font-display font-extrabold text-white text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[0.95]">
              <ScrollMaskLine>Services</ScrollMaskLine>
              <ScrollMaskLine delay={0.1} className="text-outline">
                built to
              </ScrollMaskLine>
              <ScrollMaskLine delay={0.2}>perform.</ScrollMaskLine>
            </h2>
            <Reveal delay={0.3} className="mt-8 text-[#B5A6CC] max-w-xs">
              Strategy-led design across every touchpoint your audience meets.
            </Reveal>
          </div>
        </div>

        <div className="lg:col-span-8">
          <Accordion
            type="single"
            collapsible
            defaultValue="item-0"
            className="w-full"
            data-testid="services-accordion"
          >
            {SERVICES.map((s, i) => (
              <AccordionItem
                key={s.n}
                value={`item-${i}`}
                className="border-b border-[#2D1B4E]"
              >
                <AccordionTrigger
                  data-testid={`service-trigger-${i}`}
                  className="py-8 hover:no-underline group"
                >
                  <div className="flex items-center gap-5 md:gap-8 text-left">
                    <span className="font-display text-sm text-[#6d5b95] tabular-nums">
                      {s.n}
                    </span>
                    <span className="font-display font-bold text-2xl md:text-4xl text-white group-hover:text-[#C77DFF] transition-colors duration-300">
                      {s.title}
                    </span>
                  </div>
                </AccordionTrigger>
                <AccordionContent className="pb-8 pl-10 md:pl-16">
                  <p className="text-[#B5A6CC] text-base md:text-lg max-w-xl leading-relaxed">
                    {s.body}
                  </p>
                  <div className="mt-5 flex flex-wrap gap-2">
                    {s.tags.map((t) => (
                      <span
                        key={t}
                        className="rounded-full border border-[#3a2166] px-4 py-1.5 text-xs text-[#E0B0FF]"
                      >
                        {t}
                      </span>
                    ))}
                  </div>
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
